import { render, staticRenderFns } from "./Rohertrag.vue?vue&type=template&id=0a50d88c&"
import script from "./Rohertrag.vue?vue&type=script&lang=js&"
export * from "./Rohertrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports